import * as fragment from 'raw-loader!./fragment.glsl';
import * as vertex from 'raw-loader!./vertex.glsl';

declare const THREE: any;

export class CloudMaterial extends (THREE.ShaderMaterial as { new(config): any; }) {

  constructor() {
    const config = {
      uniforms: {
        time: {value: 1.0},
        cloudDensity: {value: 0.7},
        noisiness: {value: 0.1},
        speed: {value: 0.5},
        cloudHeight: {value: 1},
        opacity: {value: 0.4},
      },
      fragmentShader: <any>fragment,
      vertexShader: <any>vertex,
      side: THREE.FrontSide,
      blending: THREE.AdditiveBlending
    };
    super(config);
  }

}







// WEBPACK FOOTER //
// ./src/app/services/lightMap/CloudMaterial/index.ts